// src/Router.tsx
import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import App from "./App"; // landing page

import BlogList from "./pages/BlogList";
import BlogPost from "./pages/BlogPost";
import SiteLayout from "./components/SiteLayout";
import { Provider } from "react-redux";
import store from "./store";


const AppRouter: React.FC = () => {
  return (

      <Routes>
        <Route path="/" element={<App />} />
       <Route element={<SiteLayout />}>
          <Route path="/blog" element={<BlogList />} />
          <Route path="/blog/:id" element={<BlogPost />} />
        </Route>

        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
  );
};

const RouterRoot: React.FC = () => (
  <Provider store={store}>
    <BrowserRouter>
      <AppRouter />
    </BrowserRouter>
  </Provider>
);

export default RouterRoot;
